/**
 * 注册install
 */

import SildeFrame from './layer.js'

// 全局变量
//
function install(Vue) {
  if (install.installed) return
  install.installed = true

  // 进行初始化
  let silder = new SildeFrame(Vue)

  Vue.prototype.$openSilde = function(moduleName, isRoot = false, propsData = {}, el) {
    // 兼容写法
    // this.$openSilde(moduleName, propsData)
    if (!this._isVue) return Promise.reject(new Error('只能组件实例调用'))
    if (typeof isRoot === 'object') {
      propsData = isRoot
      isRoot = false
    }
    return silder.open(moduleName, this, isRoot, propsData, el)
  }
  // 扩展silder
  Vue.prototype.$silder = silder
}

export default {
	install
}



// WEBPACK FOOTER //
// ./src/plugins/layer/index.js